import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";


import { t } from "i18next";
import { useBoolean } from "src/hooks/use-boolean";
import { partnerProfiles } from "src/_mock/profiles";
import { useState } from "react";
import { useRouter } from "src/routes/hooks";
import NewRoleDialog from "src/components/newrole-dialog/newroledialog";
import { useAuthContext } from "src/auth/hooks";
import { userDisplayName } from "src/utils/string-functions";
import { HOST_API } from "src/config-global";
import { CircularProgress } from "@mui/material";
import { RouterLink } from "src/routes/components";
// ----------------------------------------------------------------------
//ADMIN FOOTER ADMIN PROFILE MENU
export default function NavUpgrade() {
  //const { user } = useMockedUser();

  const router = useRouter();
  const { user, addProviderRole, updateProvider } = useAuthContext();

  const userLoading = !user?.email;

  const dialog = useBoolean();
  // Initialize state for checkboxes
  const [checkboxStates, setCheckboxStates] = useState(
    partnerProfiles.map((provider) => ({
      checked: false,
      disabled: false,
      identifier: provider.identifier,
    }))
  );

  // Handler to toggle checkbox state
  const handleCheckboxChange = (index: number) => {
    setCheckboxStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, checked: !state.checked } : state
      )
    );
  };

  const handleCreate = async () => {
    const providers = checkboxStates
      .filter((item) => item.checked) // Optional: Only include checked items
      .map((item) => item.identifier); // Extract the 'identifier' property

    if (providers.length) {
      const response = await addProviderRole(providers);
      if (response && response?.data?.created_providers[0]) {
        updateProvider(response.data.created_providers[0], providers[0]);
      }
      router.reload();
    }
  };

  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: "center",
      }}
    >
      {userLoading && (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%", py: 4 }}
        >
          <CircularProgress />
        </Stack>
      )}
      {!userLoading && (
        <Stack alignItems="center">
          <Box sx={{ position: "relative" }}>
            <Avatar
              src={HOST_API + user?.photoURL}
              alt={userDisplayName(user)}
              sx={{ width: 48, height: 48 }}
            />
            {/* <Label
            color="success"
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: "absolute",
              borderBottomLeftRadius: 2,
            }}
          >
            Free
          </Label> */}
          </Box>

          <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
            <Typography variant="subtitle2" noWrap>
              {userDisplayName(user)}
            </Typography>

            <Typography variant="body2" noWrap sx={{ color: "text.disabled" }}>
              {user?.email}
            </Typography>
          </Stack>

          <Stack
            spacing={0.5}
            direction={{ xs: "column", md: "row" }}
            sx={{ mt: 1.5, mb: 2 }}
          >
            <Button variant="contained" onClick={dialog.onTrue}>
              {t("new_role")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              href="/"
            >
              {t("player_zone")}
            </Button>
          </Stack>
          <NewRoleDialog
            open={dialog.value}
            onClose={dialog.onFalse}
            onCreate={handleCreate}
            partnerProfiles={partnerProfiles}
            checkboxStates={checkboxStates}
            handleCheckboxChange={handleCheckboxChange}
          />
        </Stack>
      )}
    </Stack>
  );
}
